import axios from "axios";
import { PURCHASE_RETURN_URL, PURCHASE_RETURN_URL_v2 } from "../../../../../constants/config";
import { REPLACE_TO_DEFAULT_QUERY_PARAMS } from "../../../Common/utils";
import { initialFilter } from "../../pages/purchase-returns/UIHelpers";

export function findPurchaseReturns(queryParams) {
  return axios.get(`${PURCHASE_RETURN_URL_v2}/list?search_key=${queryParams.searchKey || queryParams.search_key}&page=${queryParams.pageNumber || queryParams.page}&page_size=${queryParams.pageSize || queryParams.page_size}&sort_by=${queryParams.sort_by}`);
}

export function returnPurchaseOrder(order) {
  return axios.post(`${PURCHASE_RETURN_URL_v2}`, order);
}
export function independantReturnPurchaseOrder(order) {
  return axios.post(`${PURCHASE_RETURN_URL_v2}/pr-v2`, order);
}
export function independantReturnPurchaseOrderForPark(order, returnId) {
  return axios.post(`${PURCHASE_RETURN_URL_v2}/process_parked_independent_purchase_return/${returnId}`, order);
}
export function updatePurchaseReturn(order, id) {
  return axios.put(`${PURCHASE_RETURN_URL_v2}/${id}`, order);
}

export function changeStatus(queryParams) {
  return axios.patch(`${PURCHASE_RETURN_URL}/${queryParams.id}`, {
    status: parseInt(queryParams.status),
  });
}
export function getPurchaseReturnsById(id) {
  return axios.get(`${PURCHASE_RETURN_URL_v2}/${id}`, {
  });
}

export function getPurchaseReturns(queryParams) {
  queryParams = queryParams === undefined ? initialFilter : REPLACE_TO_DEFAULT_QUERY_PARAMS(queryParams, initialFilter);
  return axios.get(
    `${PURCHASE_RETURN_URL_v2}/list?search_key=${queryParams.searchKey}&page=${queryParams.pageNumber}&page_size=${queryParams.pageSize}&supplier_ids=${queryParams.supplier_ids ? queryParams.supplier_ids : []}&channel_ids=${queryParams.channel_ids ? queryParams.channel_ids : []}&purchase_order_no=${queryParams.purchase_order_no ? queryParams.purchase_order_no : ""}&purchase_return_no=${queryParams.purchase_return_no ? queryParams.purchase_return_no : ""}&return_date=${queryParams.return_date ? queryParams.return_date : ""}&sort_by=${queryParams.sortField}:${queryParams.sortOrder}`)
}

export function voidPurchaseReturn({ id, status }) {
  return axios.patch(`${PURCHASE_RETURN_URL_v2}/${id}`, {
    status: parseInt(status),
  });
}

export function parkIndependentReturn(payload) {
  return axios.post(`${PURCHASE_RETURN_URL_v2}/park_independent_purchase_return`, payload);
}

export function updateParkIndependentReturn(payload, returnId) {
  return axios.put(`${PURCHASE_RETURN_URL_v2}/park_independent_purchase_return/${returnId}`, payload);
}

export function deleteParkIndependentReturn(itemId) {
  return axios.delete(`${PURCHASE_RETURN_URL_v2}/${itemId}`);
}

// Record a CASH/CHEQUE payment received from the supplier against a purchase return.
// Voids the return's outstanding store credit (and its applications) and books the received
// cash/cheque in its place. `paymentData` = { payment_date, payments: [{ payment_type, amount, ... }] }.
export function receivePurchaseReturnPayment(id, paymentData) {
  return axios.post(`${PURCHASE_RETURN_URL_v2}/${id}/payment`, paymentData);
}

// List a supplier's unpaid / partially-paid purchase returns (those with an outstanding
// refundable amount). Feeds the supplier ledger "Receive Payment" drawer.
export function getRefundableReturns(params) {
  return axios.get(`${PURCHASE_RETURN_URL_v2}/refundable-returns`, { params });
}

// Distribute a received cash/cheque payment across a supplier's purchase returns.
// `payload` = { supplier_id, return_split_info: { [return_id]: amount }, payment: { ... } }.
export function bulkReceiveReturnPayment(payload) {
  const splits = payload.return_split_info || {};
  Object.keys(splits).forEach((key) => {
    if (Number(splits[key]) === 0) {
      delete splits[key];
    }
  });
  return axios.post(`${PURCHASE_RETURN_URL_v2}/bulk_payment`, { ...payload });
}